<template>
<a-spin :spinning="spinLoading" tip="上传文件中......">
  <a-space direction="vertical" style='width: 100%'>
    <div style="margin-bottom: 5px;">
      <span v-for="(item,i) in folderDefine" :key="i">
        <span style="color: red;" v-show='item.isNeed == 1'>*</span>
        <a-upload
          name="file"
          :multiple="true"
          :action="uploadAction"
          :headers="tokenHeader"
          :data="item"
          :accept="item.accept == null? '*':item.accept"
          :showUploadList="false"
          :beforeUpload="e => beforeUpload(e,item)"
          @change="handleChange">
          <a-button style="margin-right:8px;margin-top: 5px ;position: relative" >
            <a-icon type="upload"/>
            {{item.typeZh}}
            <span v-if="item.msg" style="color: red;float: left;position: absolute;bottom: -14px;left:3px;font-size: 10px">
              {{item.msg}}
            </span>
          </a-button>

        </a-upload>
      </span>
    </div>
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="false"
      @change="handleTableChange"
    >

        <span slot="action" slot-scope="text, record">
          <a @click="handleDownload(record)">下载</a>
          <a-divider v-show='(record.type=="tenderZbf")' type="vertical"/>
          <a v-show='(record.type=="tenderZbf")' @click="previewFile(record)">预览文件</a>
          <a-divider type="vertical"/>
          <a @click="deleteFile(record)">删除</a>
        </span>

    </a-table>
  </a-space>
</a-spin>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { downloadFile, getAction, putAction } from '@api/manage'
import {FzisListMixin} from '@/mixins/FzisListMixin'

export default {
  name: 'upload',
  mixins: [FzisListMixin],
  data() {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '文件名称',
          align: "center",
          dataIndex: 'fileName'
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'typeZh'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
      url: {
        list: "/ebid-ce/file/list",
        delete: "/ebid-ce/file/delete",
        minioUpload: "/ebid-ce/file/upload",
        download: "/ebid-ce/file/download",
        minioDownload: "/ebid-ce/file/minioDownload"
      },
      disableMixinCreated: true,
      spinLoading: false,
      previewTednerZbfVisible: false,
    }
  },
  props:{
    folderDefine:{},
    bidProjectId:{},
    limitSize:{
      type:Number,
      required:false,
      default:500
    },
    fileNameLimitLength:{
      type:Number,
      required:false,
      default:100
    }
  },
  computed: {
    uploadAction() {
      return window._CONFIG['domianURL'] + this.url.minioUpload;
    },
  },
  watch: {
    folderDefine(newName, oldName) {
      var s = "";
      for (let i = 0; i < this.folderDefine.length; i++) {
        if(this.bidProjectId != null ) {
          this.folderDefine[i].bidId = this.bidProjectId;
        }
        s += this.folderDefine[i].type + ",";
      }
      if(s.length > 1) {
        s = s.substr(0,s.length - 1);
      }
      if(this.bidProjectId != null ) {
        this.queryParam.bidId = this.bidProjectId;
      }
      this.queryParam.fileTypes = s;
      console.log('文件参数',this.queryParam);
      this.loadFileList()
    },
    bidProjectId(newVal, oldVal) {
      this.bidProjectId = newVal
      if(this.bidProjectId != null ) {
        this.queryParam.bidId = this.bidProjectId;
        for (let i = 0; i < this.folderDefine.length; i++) {
          if(this.bidProjectId != null ) {
            this.folderDefine[i].bidId = this.bidProjectId;
          }
        }
        this.loadFileList()
      }
    }
  },
  created() {
    var s = "";
    for (let i = 0; i < this.folderDefine.length; i++) {
      if(this.bidProjectId != null ) {
        this.folderDefine[i].bidId = this.bidProjectId;
      }
      s += this.folderDefine[i].type + ",";
    }
    if(s.length > 1) {
      s = s.substr(0,s.length - 1);
    }
    if(this.bidProjectId != null ) {
      this.queryParam.bidId = this.bidProjectId;
    }
    this.queryParam.fileTypes = s;
    console.log('文件参数',this.queryParam);

    if (this.bidProjectId!=null)
      this.loadFileList()
  },
  methods: {
    beforeUpload(file,defineParam) {
      //限制文件需要上传正确的类型
      if (defineParam.accept){
        let types = defineParam.accept.replace(/\./g, '').split(",");
        if (!types.includes(file.name.split(".").pop())){
          this.$message.error("只允许上传" + defineParam.accept.replace(/\./g, '') + "类型文件")
          return false
        }
      }
      //限制文件大小
      const isLt = file.size / 1024 / 1024 < this.limitSize;
      if (!isLt) {
        this.$message.error('上传的文件大小不能超过'+this.limitSize+'MB');
        return false;
      }
      //限制文件名称长短
      if (file.name.length > this.fileNameLimitLength){
        this.$message.error('上传的文件名称不能超过'+this.fileNameLimitLength+'个字符长度');
        return false;
      }
      this.$emit('uploadChange','uploadBegin')
      this.spinLoading = true;
      return true
    },
    deleteFile(rec) {
      var that = this;
      that.$confirm({
        title: "确认删除",
        content: "是否删除选中文件?",
        onOk: function () {
          that.deleteFileReq(rec)
        }
      });
    },
    // 预览招标文件
    previewFile(rec) {
      this.previewTednerZbfVisible = true;
      const params = { id: this.bidProjectId };
      // params.sectionId = this.sectionInfo.id;
      let routeData = this.$router.resolve({
        path: '/bobidappraise/bidProjectFile',
        query: params,
      });
      window.open(routeData.href, '_blank');
    },
    deleteFileReq: function (rec) {
      if(!this.url.delete){
        this.$message.error("请设置url.delete属性!")
        return
      }
      var that = this;
      putAction(that.url.delete, {id: rec.id}).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadFileList();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        this.$emit('uploadChange','uploadFinish')
        this.spinLoading = false;
        if (info.file.response.success) {
          this.loadFileList()
          this.$message.success(`${info.file.name} 上传成功!`);

        } else {
          this.$message.error(`${info.file.response.message}`);
        }
      } else if (info.file.status === 'error') {
        this.$emit('uploadChange','uploadFinish')
        this.spinLoading = false;
        this.$message.error(`${info.file.response.message}`);
      }
    },
    handleDownload(rec) {
      var that = this;
      getAction(that.url.minioDownload,{id: rec.id}).then(res => {
        if(res.success) {
          console.log(res.result);
          downloadFile(res.result , rec.fileName);
        }
      })
    },
    validate() {
      let m = {};
      for (var i = 0; i < this.dataSource.length; i++) {
        if(m[this.dataSource[i].type] == null || typeof(m[this.dataSource[i].type]) == 'undefined' ) {
          m[this.dataSource[i].type] = 1;
        } else {
          m[this.dataSource[i].type] = m[this.dataSource[i].type] + 1;
        }
      }
      for (let i = 0; i < this.folderDefine.length; i++) {
        if (this.folderDefine[i].isNeed == 1 && (m[this.folderDefine[i].type] == null || typeof(m[this.folderDefine[i].type]) == 'undefined' || m[this.folderDefine[i].type] < 1)) {
          return false;
        }
      }
      return true;
    },
    getFileId() {
      let m = [];
      for (var i = 0; i < this.dataSource.length; i++) {
        m.push(this.dataSource[i].id);
      }
      return m;
    },
  }
}
</script>

<style scoped>

</style>